var Handlebars = require('/home/circleci/project/node_modules/handlebars/lib/index.js');
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(depth0,helpers,partials,data) {
  return "data-iframe-height";
  },"3":function(depth0,helpers,partials,data) {
  return "hide";
  },"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, buffer = "<div ";
  stack1 = helpers.unless.call(depth0, ((stack1 = (depth0 != null ? depth0.me : depth0)) != null ? stack1.isJoined : stack1), {"name":"unless","hash":{},"fn":this.program(1, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += " class=\"auth-view-box ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 != null ? depth0.me : depth0)) != null ? stack1.isJoined : stack1), {"name":"if","hash":{},"fn":this.program(3, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += "\">\n    <div class=\"auth-view-box-join-view\">";
  stack1 = this.invokePartial(partials.join, '', 'join', depth0, undefined, helpers, partials, data);
  if (stack1 != null) { buffer += stack1; }
  return buffer + "</div>\n</div>\n";
},"usePartial":true,"useData":true});